import React, { useCallback, useEffect, useState } from "react";
import { FormGroup, Input, Label } from "reactstrap";
import { formatRP } from "../../Utils/externalFunctions";
import DataTable from "react-data-table-component";
import { STATUS_DATA_TYPE, getStatusDataName } from "../../Constant/StatusData";
import DataTableTitle from "./DataTableTitle";
import { FORM_TYPE } from "../../Constant/FormType";
import Select from "react-select";

const UMOCheckboxSelect = ({
  umoList,
  selectedUMO,
  umoOpt,
  handleCheckboxUMO,
  formTransaksi,
  formType,
}) => {
  // const [selectedRows, setSelectedRows] = useState([]);
  // useEffect(() => {
  //   setSelectedRows(umoList);
  // }, [umoList]);

  // const toggleRowSelection = (row) => {
  //   const isSelected = selectedRows.includes(row);

  //   if (isSelected) {
  //     setSelectedRows(selectedRows.filter((selected) => selected !== row));
  //   } else {
  //     setSelectedRows([...selectedRows, row]);
  //   }
  // };

  // const daftarColumns = [
  //   {
  //     name: <DataTableTitle text={"Diajukan Oleh"} />,
  //     selector: (row) => row.diajukan_oleh,
  //     sortable: true,
  //   },
  //   {
  //     name: <DataTableTitle text={"Nilai"} />,
  //     selector: (row) => "Rp. " + formatRP(row.nilai),
  //     sortable: true,
  //   },
  //   {
  //     name: <DataTableTitle text={"Keterangan"} />,
  //     selector: (row) => row.keterangan,
  //     sortable: true,
  //     wrap: true,
  //   },
  //   {
  //     name: <DataTableTitle text={"Status"} />,
  //     selector: (row) =>
  //       getStatusDataName(row.id_status_umo, STATUS_DATA_TYPE.UMO),
  //     sortable: true,
  //   },
  // ];

  return (
    <>
      <Label for="exampleAddress2">Terkait UMO</Label>
      {/* <DataTable
        columns={daftarColumns}
        data={filterUMO(umoList)}
        pagination
        selectableRowsHighlight
        highlightOnHover
        persistTableHead
        selectableRows
        selectableRowSelected={selectableRowSelected}
        fixedHeader
        fixedHeaderScrollHeight="300px"
        onSelectedRowsChange={handleCheckboxUMO}
      /> */}
      {umoOpt && selectedUMO ? (
        <Select
          value={selectedUMO}
          isMulti
          isClearable
          isSearchable
          name="id_umo_list"
          options={umoOpt}
          className="basic-multi-select"
          classNamePrefix="select"
          onChange={handleCheckboxUMO}
        />
      ) : null}
    </>
  );
};

export default UMOCheckboxSelect;
